<form [formGroup]="warrantyCodeValidationFormGroup"  id="step-serial-number-search" class="h-full">
  <div class="flex flex-1 flex-col rounded-card h-full overflow-visible pb-6">
    <section class="row">
      <div class="flex flex-col col-12">
        <h2 data-testid="warranty-validation-title" class="pb-2">{{ 'WARRANTY_ACTIVATION.WARRANTY_CODE_VALIDATION' | translate }}</h2>
        <label data-testid="warranty-validation-label"  class="block text-sm mb-4" for="warranty-code-search">{{ 'WARRANTY_ACTIVATION.INTRODUCE_WARRANTY_CODE' | translate }}:</label>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
        <div class="flex items-stretch camera-btn-field-wr">
          <input data-testid="search" type="text" id="search-sn" formControlName="warrantyCode" autocomplete="off" disallowSpaces>
          <textbox-camera data-testid="search-camera" class="shrink-0 self-stretch flex items-center"
          (qrCodeScanned)="onQRCodeScanned($event)"></textbox-camera>
        </div>
      </div>
      <div class="field-wr flex flex-col col-12 col-sm-12 col-md-5 col-lg-6 col-xl-4">
        <button data-testid="validate-warranty-btn" class="btn primary-btn" (click)="onValidateWarrantyCode()">{{ 'WARRANTY_ACTIVATION.BTN_VALIDATE_WARRANTY_CODE' | translate }}</button>
      </div>
      @if (isFormSubmitted && isResultsEmpty) {
        <div>
          <div class="flex flex-col col-12">
            <h2 data-testid="validate-warranty-result-label" class="pb-2">{{ 'WARRANTY_ACTIVATION.VALIDATION_RESULTS' | translate }}</h2>
          </div>
          <hr role="presentation" class="w-full mt-1 mb-2 border-t">
          <p data-testid="validate-warranty-not-found" class="font-medium">{{ 'WARRANTY_ACTIVATION.WARRANTY_CODE_NO_RESULTS_FOUND' | translate }}</p>
        </div>
      }
    </section>
  </div>
</form>
